import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

const MoreLikeThis = dynamic(
	() => import('./MoreLikeThis/MoreLikeThis'),
	{ ssr: false },
);

export default function RelatedContent(props) {
	const { article } = props;

	return (
		<div className="related-content" role="complementary">
			<MoreLikeThis post={article} />
		</div>
	);
}

RelatedContent.propTypes = {
	article: PropTypes.object.isRequired,
};
